import type { JSX } from 'react'

import { ButtonFonts } from 'atoms/Button'
import { PlayPrimaryButton } from 'atoms/Button/Templates'
import { IconNames } from 'atoms/Icon/Icon.h'
import { TextAligning, TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import {
  PlayerSignToWatchBtnWrapperSC,
  PlayerSignToWatchPopupSC,
  PlayerSignToWatchPopupSmallSC,
} from './PlayerSignInToWatchPopup.styled'

export interface IPlayerSignInToWatchPopup {
  title: string
  buttonText: string
  onSubmit: (e: React.MouseEvent) => void
  smallPlayer?: boolean
  isFullscreen?: boolean
}

export const PlayerSignInToWatchPopup = ({
  title,
  buttonText,
  onSubmit,
  smallPlayer,
  isFullscreen,
}: IPlayerSignInToWatchPopup): JSX.Element => {
  const isSmallPlayer = smallPlayer && !isFullscreen

  const config = isSmallPlayer
    ? {
        titleFont: TextBoxTypes.FontLgBold,
        childrenGap: FIXED_INDENTS.INDENT_40,
      }
    : {
        titleFont: TextBoxTypes.FontXlBold,
        childrenGap: FIXED_INDENTS.INDENT_60,
      }

  const { titleFont, childrenGap } = config

  const WrapperSC = isSmallPlayer
    ? PlayerSignToWatchPopupSmallSC
    : PlayerSignToWatchPopupSC

  return (
    <WrapperSC gap={childrenGap}>
      <TextBox
        title={title}
        color={Colors.TEXT_ICON_PRIMARY}
        font={titleFont}
        maxLines={2}
        alignment={TextAligning.Center}
      />
      <PlayerSignToWatchBtnWrapperSC>
        <PlayPrimaryButton
          icon={IconNames.none}
          title={buttonText}
          onClick={onSubmit}
          font={ButtonFonts.FontSmBold}
        />
      </PlayerSignToWatchBtnWrapperSC>
    </WrapperSC>
  )
}
